import React, { useState } from "react";

import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { parametarExtractor } from "../../utils/parametarExtractor";

import moment from "moment";

const InputCSS = {
    fontSize: "14px",
    ".MuiInputBase-root": {
        height: "28px",
        fontSize: "12px",
        background: "white",
    },
    ".MuiSvgIcon-root": {
        width: "20px",
        color: "#999",
    },
    ".Mui-disabled": {
        background: "transparent",
    },
    ".MuiFormHelperText-root": {
        marginLeft: 0,
        marginRight: 0,
    },
};

const dateFormat = "YYYY-MM-DD";

const createStringValue = (value) =>
    value ? moment(value).format(dateFormat) : undefined;

const DateCustom = (props) => {
    const { t } = useTranslation();
    const errorTranslation = t("sulu_admin.passports.past_date_error");

    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState("");

    const params = parametarExtractor(props);

    const minDate = React.useMemo(() => {
        if (params.onlyFutureDate) {
            return new Date();
        }

        if (!params.notBefore) {
            return undefined;
        }

        const candidate = props.data?.[params.notBefore] ?? params.notBefore;
        return candidate ? new Date(candidate) : undefined;
    }, [params.onlyFutureDate, params.notBefore, props.data]);

    const validateDate = React.useCallback(
        (formattedValue) => {
            if (!formattedValue || !minDate) {
                setError("");
                return;
            }

            const target = new Date(formattedValue);
            target.setHours(0, 0, 0, 0);

            const limit = new Date(minDate);
            limit.setHours(0, 0, 0, 0);

            setError(target < limit ? errorTranslation : "");
        },
        [errorTranslation, minDate],
    );

    const handleChange = (value) => {
        const formattedValue = createStringValue(value);
        validateDate(formattedValue);

        props.onChange(formattedValue);
        props.onFinish();
    };

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    onClose={() => {
                        setIsEditing(false);
                    }}
                    onOpen={() => {
                        setIsEditing(true);
                        if (params.notBefore) {
                            const newDate = props.data[params.notBefore]
                                ? new Date(props.data[params.notBefore])
                                : new Date(params.notBefore);
                            if (newDate.getTime() !== minDate.getTime()) {
                                setMinDate(newDate);
                            }
                        }
                    }}
                    format="dd/MM/yyyy"
                    sx={{
                        ...InputCSS,
                    }}
                    value={props.value ? new Date(props.value) : null}
                    onChange={handleChange}
                    minDate={isEditing ? minDate : undefined}
                    disabled={!!props.disabled}
                    slots={{
                        textField: TextField,
                    }}
                    slotProps={{
                        textField: {
                            error: !!error,
                            helperText: error,
                        },
                    }}
                />
            </LocalizationProvider>
        </div>
    );
};

export default DateCustom;
